import { PublicAquisitionData } from "./types";

export const getMonthName = (month: number, locale = "ro-RO") => {
  const date = new Date();
  date.setMonth(month);
  return date.toLocaleString(locale, { month: "long" });
};

export const getSeapUrl = (id: string, type: PublicAquisitionData["index"]) => {
  const istoric = Number(id) < 100_000_000 ? true : false;
  switch (type) {
    case "achizitii-offline": {
      return `https://${
        istoric ? "istoric." : ""
      }e-licitatie.ro/pub/direct-acquisition/award-notice/view/${id}`;
    }
    case "achizitii-directe": {
      return `https://${istoric ? "istoric." : ""}e-licitatie.ro/pub/direct-acquisition/view/${id}`;
    }
    case "licitatii-publice": {
      return `https://${
        istoric ? "istoric." : ""
      }e-licitatie.ro/pub/notices/ca-notices/view-c/${id}`;
    }
  }
};

export const formatNumber = (number: number, locale = "ro-RO") => {
  return parseFloat(number.toFixed(0)).toLocaleString(locale);
};
